import { Component, Input } from '@angular/core';
import { ControlService } from '../library/control.service';
import { PlayerService } from '../library/player.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { RealtimeService } from '../library/realtime/realtime.service';
import { CallStoreService } from '../library/call-store/call-store.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
  selector: 'app-end-call-early',
  templateUrl: './end-call-early.component.html',
  styleUrls: ['./end-call-early.component.scss'],
  standalone: false
})
export class EndCallEarlyComponent {
  @Input() controlService: ControlService | undefined;
  @Input() playerService: PlayerService | undefined;
  @Input() realtimeService: RealtimeService | undefined;

  constructor(
    private callStore: CallStoreService,
    private amplitudeService: AmplitudeService,
    private logger: LoggerService
  ) {}

  endCall() {
    this.logger.log('[CALL] end click - end call');

    if (this.controlService) {
      // Sending the Event of Clicking on End Call after end early to Amplitude
      this.amplitudeService.trackEvent(
        AmplitudeTrackingEvents.END_CALL_MODAL_CLICK_ENDCALL,
        {
          call_type: this.controlService?.callType,
        }
      );
      if (this.controlService.isRealTimeCall) {
        console.log('User clicked "End Call" button on modal end call early.');
        this.realtimeService?.endRealtimeConversation(true);
        return;
      }
      this.controlService.endCall(true);
      this.controlService.goBackToAssigment();
      this.controlService.resetRecognitionControls();
      this.controlService.isEndCallTriggered = true;
    }
  }

  async resume() {
    this.logger.log('[CALL] end click - resume');

    this.callStore.setIsResumeFromModal(true);
    this.callStore.setResumeFromModalType('end-call-early');
    this.callStore.setDisableEndCallButton(false);
    if (this.controlService && this.playerService) {
      // Sending the Event of Clicking on End Call after end early to Amplitude
      this.amplitudeService.trackEvent(
        AmplitudeTrackingEvents.END_CALL_MODAL_CLICK_RESUME,
        {
          call_type: this.controlService?.callType,
        }
      );

      if (this.controlService.isRealTimeCall) {
        this.realtimeService?.cancelEndCallEarly();
      } else {
        await this.controlService.unpauseCall();
      }
      this.controlService.isEndCallTriggered = false;
      this.callStore.setIsSendingAnswer(false);
    }
  }
}
